document.addEventListener('DOMContentLoaded', function () {
  const popouts = document.querySelectorAll('[data-header-popout]');

  popouts.forEach(function (popout) {
    const toggle = popout.querySelector('[data-header-popout-toggle]');
    const list = popout.querySelector('[data-header-popout-list]');
    const input = popout.querySelector('[data-header-popout-input]');
    const options = popout.querySelectorAll('[data-header-popout-option]');

    // Toggle open/close
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = list.classList.contains('is-visible');
      // Close all other popouts first
      document.querySelectorAll('[data-header-popout-list].is-visible').forEach(function (el) {
        el.classList.remove('is-visible');
        el.closest('[data-header-popout]').querySelector('[data-header-popout-toggle]').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        list.classList.add('is-visible');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    // Select option
    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = option.getAttribute('data-value');
        toggle.closest('form').submit();
      });
    });
  });

  // Close on outside click
  document.addEventListener('click', function () {
    document.querySelectorAll('[data-header-popout-list].is-visible').forEach(function (el) {
      el.classList.remove('is-visible');
      el.closest('[data-header-popout]').querySelector('[data-header-popout-toggle]').setAttribute('aria-expanded', 'false');
    });
  });

  // Close on Escape
  document.addEventListener('keyup', function (e) {
    if (e.code !== 'Escape') return;
    document.querySelectorAll('[data-header-popout-list].is-visible').forEach(function (el) {
      el.classList.remove('is-visible');
      el.closest('[data-header-popout]').querySelector('[data-header-popout-toggle]').setAttribute('aria-expanded', 'false');
    });
  });
});